import styled, { css, keyframes } from 'styled-components';

import RoutingModule from './RoutingModule';
import { listItemStyles } from 'modules/fleet/list';

const fadeInOut = keyframes`
  0% {
    opacity: 0.5;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 0.5;
  }
`;

const fadeInOutRules = css`
  ${fadeInOut} 2s infinite;
`;

export default styled(RoutingModule)`
  display: flex;

  .route-container {
    display: flex;
    justify-content: stretch;
    flex-direction: column;
    height: 100%;
    position: relative;
    background: var(--grey500);
    color: var(--grey900);
    overflow: hidden;
    min-width: 590px;
  }

  .map-container {
    width: 640px;
    display: flex;
    flex-direction: column;
  }

  .map-content {
    flex: 1;
    position: relative;
  }

  .content {
    overflow: hidden;
    overflow-y: auto;
    box-shadow: 0 1px 5px 0 rgb(0 0 0 / 20%);
    border-radius: 8px;
    background: var(--white);
    overflow: hidden;
    margin: 0.8rem;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .header {
    height: 32px;
    background-color: var(--grey800);
    display: flex;
    .close {
      width: 32px;
      height: 32px;
      color: var(--white);
      background-color: var(--grey900);
      border: 0;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        pointer-events: none;
        fill: var(--grey500) !important;
      }
      -webkit-appearance: none;
    }
  }

  .header-content {
    color: var(--white);
  }

  .map-actions {
    padding: 8px;
    position: absolute;
    z-index: 3;
    display: flex;
    align-items: center;
  }

  .subheader {
    padding: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid var(--grey200);
  }

  .vehicle-info {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .footer {
    background: var(--white);
    padding: 0 0.8rem;
  }

  .summary {
    display: flex;
    min-height: 48px;
    align-items: flex-start;
    padding-top: 8px;
    > div {
      min-width: 80px;
      text-align: left;
    }
    .distance {
      min-width: auto;
    }
    .push {
      flex: 1;
    }
    .hint {
      color: var(--grey500);
      font-size: 11px;
      line-height: normal;
    }
    .faded-in {
      font-weight: bold;
    }
    .faded-out {
      color: var(--grey700);
    }
    .amount {
      font-size: 14px;
      line-height: normal;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
  }

  .edit-link,
  .distance-link {
    margin-left: 8px;
    button {
      padding: 0;
      height: auto;
    }
  }

  .amount-container {
    margin-right: 8px;
    margin-left: 8px;
  }

  .actions {
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    > button {
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .stops-header {
    background: var(--grey300);
    font-weight: bold;
    padding: 0.8rem;
    line-height: normal;
    .small {
      font-weight: normal;
      color: var(--grey700);
      display: inline-block;
      margin-left: 4px;
    }
  }

  .stops {
    flex: 1;
    background-color: var(--grey100);
    overflow: hidden;
    overflow-y: scroll;
  }

  .stop {
    height: 36px;
    display: flex;
    ${listItemStyles}
  }

  .stop .remove-container {
    opacity: 0;
    transition: opacity 0.2s;
  }

  .stop:hover .remove-container {
    opacity: 1;
    transition: opacity 0.2s;
  }

  .fullLoading {
    position: absolute;
    background: #000;
    opacity: 0.5;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    animation: ${fadeInOutRules};
  }

  .cell__extra {
    width: 24px;
    display: inline-flex;
    justify-content: center;
    margin-right: 4px;
  }

  .stop:hover {
    cursor: grab;
  }

  .stop.noDraggable:hover {
    cursor: not-allowed;
  }

  .stop.defaultCursor:hover {
    cursor: default;
  }

  .stop.noHover:hover {
    .cell {
      background-color: white;

      &__dark {
        background-color: var(--grey100);
      }
    }
  }

  .stop .cell.cell__status__done,
  .stop:hover .cell.cell__status__done {
    background-color: var(--primary300);
    svg {
      fill: white;
      opacity: 0.5;
      width: 16px;
    }
  }

  .stop .cell.cell__status__inProgress,
  .stop:hover .cell.cell__status__inProgress {
    background-color: var(--success300);
    svg {
      fill: var(--success700);
      opacity: 0.5;
      width: 16px;
    }
  }

  .stop {
    &,
    &:hover {
      .cell.cell__status__improvement {
        background-color: var(--deep-purple100);
        color: var(--deep-purple500);
      }
    }
  }

  .RoutingInfoWindow {
    font-family: 'Roboto', Verdana, sans-serif;
    font-size: 1.2rem;
    font-weight: normal;
    width: 100%;
    height: 100%;
    padding-top: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .RoutingInfoWindowStop {
      display: flex;
      align-items: center;
    }
    .action-container {
      margin-left: 8px;
      margin-right: 8px;
    }
  }

  .gm-style {
    .gm-style-iw-c,
    .gm-style-iw-d {
      padding: 0;
    }
  }
  .gm-style .gm-style-iw-d {
    overflow: hidden !important;
  }
`;
